<template>
	<div class="cotent_who">
		<div class="content_top">
			<img src="@/assets/images/who/banner.jpg" alt="" class="w100">
			<!-- <h3>Who We Are</h3> -->
		</div>
		<div class="content_center">
			<div class="container">
				<div class="team_text">
					<h3>Our team</h3>
					<h4>Hisan is dedicated to providing quality and cost-effective wear solutions that completely fulfill the requirements of clients.</h4>
					<p>Hisan (Tianjin) Co., Ltd. is a high-tech company specializing in the production of chromium carbide overlay wear resistant plates, wear resistant ceramics, wear resistant castings, overlay wear pipes, welding wires and abrasion resistant steel plates. Our products are resistant to wear, erosion, high temperature, stress, impact and other factors that cause wear. Over the years, Hisan has gathered experienced and skilled professionals from mining, cement, material handling, thermal power and other fields. With the leading R & D team, we continuously break through technical barriers, improve products, and develop more professional wear resistant solutions to make products much more durable. Hisan is constantly striving to meet with the wear needs of various working conditions!</p>
				</div>
				<img src="@/assets/images/who/team1.jpg" alt="" class="team"/>
				
			</div>
				
		</div>
		<div class="content_bottom">
			<!-- <img src="@/assets/images/who/who_bg.jpg" alt="" class="w100" style="opacity: 0;"> -->
			<div class="container">
				<div class="icon_box">
					<ul>
						<li>
							<img src="@/assets/images/who/icon_1.png" alt="" />
							<p>Customer Oriented Quality<br/>Control Process</p>
						</li>
						<li>
							<img src="@/assets/images/who/icon_2.png" alt="" />
							<p>Relentless R&D to<br/>improve our technique<br/>and products</p>
						</li>
						<li>
							<img src="@/assets/images/who/icon_3.png" alt="" />
							<p>Reducing Waste</p>
						</li>
						<li>
							<img src="@/assets/images/who/icon_4.png" alt="" />
							<p>Select the best products<br/>for the right application</p>
						</li>
						
						<li>
							<img src="@/assets/images/who/icon_5.png" alt="" />
							<p>Address product<br/>performance issues<br/>promptly and effectively</p>
						</li>
                        <li>
                            <img src="@/assets/images/who/icon_10.png" alt="" />
                            <p>Comprehensive one <br/>stop wear solution</p>
                        </li>
					</ul>
				</div>
				<div class="text_box">
					<h3>Our Quality Policy</h3>
					<p>Hisan's products are manufactured under strictly controlled quality management system. Our objective is to strengthen our position as a leading provider of impact and wear solutions.To achieve this goal, all Hisan's employees are committed to our quality system by:</p>
				</div>	
			</div>
			
		</div>
		<div class="content_icon">
			<h3>Integerity</h3>
			<ul>
				<li v-for="(item,index) in iconList" :key="index" >
					<img :src="item.imgsrc" alt="" class=""/>
					<p>{{item.name}}</p>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				tips6List:[
					{
						imgsrc:require('@/assets/images/why/icon_1.png'),
						name:'Persuit of Quality',
						text:"High quality is our obligation! Hisan's products are all produced under tightly controlled parameters and would be inspected before leaving our plants.",
					},
					{
						imgsrc:require('@/assets/images/why/icon_2.png'),
						name:'Support Service',
						text:'Great Service is our mission! Hisan provides quick reactions to your queries within 24 hours. We are commited to providing exceptional customer support.',
					},
					{
						imgsrc:require('@/assets/images/why/icon_3.png'),
						name:'Expertise',
						text:'We are a gorup of professional people with 10 years of extensive industy experience. Hisan assists its clients with proper material selection, industial design and installation.',
					},
				],
				iconList:[
					{
						imgsrc:require('@/assets/images/who/icon_6.png'),
						name:'Take responsibility \nfor our own actions',
					},
					{
						imgsrc:require('@/assets/images/who/icon_7.png'),
						name:'Treat people with \nrespect,help others\n and give support',
					},
					{
						imgsrc:require('@/assets/images/who/icon_8.png'),
						name:'Utilise combined \nexperience and the \nstrength of the team',
					},
					{
						imgsrc:require('@/assets/images/who/icon_9.png'),
						name:'Constantly looking for \nnew innovative ideas \nand technological advances',
					},
					
				],	
			}
		}
	}
</script>

<style scoped lang="scss">
    .cotent_who{
        .content_center{
        	width:100%;padding: 4.6875vw 0;
        	.container{display: flex;justify-content: space-between;align-items: flex-end;}
        	.team_text{width: 54%;
        		h4{font-size: 20px;color: #333;margin: 1vw 0 0.5vw;line-height: 1.8;}
        		p{font-size: 16px;color: #666;line-height: 1.8;text-align: justify;}
        	}
        	.team{
        		width: 42%;margin-bottom:1.5vw;
        	}
        	h3{font-size: 48px;color: #ad1f24;
        		position: relative;line-height: 1.8;
        		&::after{
        			content: '';
        			border-bottom: solid 4px #ad1f24;width: 120px;position: absolute;bottom: 0;left:0;
        		}
        	}
        	
        }
        .content_bottom{
        	position: relative;background: url(../../assets/images/who/who_bg.jpg) no-repeat center;background-attachment: fixed;height:calc(100vw / 1920 * 800);background-size: cover;
        	.container{
        		height: 100%;display: flex;align-items: center;position: relative;left:0;right: 0;top:0;margin: auto;
        		.icon_box{height: 100%;display: flex;align-items: center;
        		ul{width:80%;height: calc(100vw / 1920 * 800);
        			li{width:49.5%;height: 33.3333%;display: flex;
        			flex-direction: column;padding:5% 5% 0;transition: all .9s ease;
        			&:hover{
        				img{display: none;}
        				background: rgba(173,31,36,0.85);
        				p{transition: all 1.9s ease;}
        			}
        				border-bottom: solid 1px #e5e6e5;float: left;
        				border-right: solid 1px #e5e6e5;
        				img{width: 25%;margin-bottom: 10px;}
        				p{font-size: 16px;color: #fff;margin: 0;}
        				&:last-child{border: none;}
        				&:nth-child(2){border-right: none;}
        				&:nth-child(5){border-bottom: none;
        					
        				}
        			}
        		}
        		}
        	}
        	.text_box{
        		width: 45%;margin: auto;
        		p{
        			font-size: 16px;color: #fff;line-height: 1.8;
        		}
        	}
        	h3{font-size: 48px;color: #fff;margin-bottom: 44px;
        		@media (max-width: 1440px) {
        			font-size: 30px;
        		}
        		position: relative;line-height: 1.8;
        		&::after{
        			content: '';
        			border-bottom: solid 4px #fff;width: 120px;position: absolute;bottom: 0;left:0;
        		}
        	}
        	
        }
        .content_icon{
        	width: 72.9%;margin:3vw auto;
        	h3{font-size: 48px;color: #ad1f24;margin: 44px 0;
        		position: relative;line-height: 1.8;
        		&::after{
        			content: '';
        			border-bottom: solid 4px #ad1f24;width: 120px;position: absolute;bottom: 0;left:0;
        		}
        	}
        	ul{
        		display: flex;padding: 3vw 0;
        		li{
        			width: 25%;display: flex;flex-direction: column;
        			img{width: 150px;margin: auto;}
        			p{
        				font-size: 18px;color: #666;margin:30px 0 0 0;
        				white-space: pre-wrap;text-align: center;
        			}
        			&:hover{
        				img{animation: jump 0.5s ease-in-out infinite;}
        				
        			}
        		}
        	}
        }
        @keyframes jump {
        	0%,
        	100% {
        		transform: translateY(0);
        	}
        	50% {
        		transform: translateY(-10px);
        	}
        }
    }
	
</style>